import axiosI  from '../Service/service';
import { ENABLE, DISABLE, GET_ALBUM, DELETE_USEROWNFEED, ADD_ALBUM } from './actionTypes';
import * as constants from '../Constants';

export const addAlbums=(dictionary)=>{
    return (dispatch => {
	    dispatch({type: ENABLE, payload: true});
      // dispatch({type: 'BEFORE_ADD', payload: true});
        return axiosI.post(constants.API.addFeedByUserApi,dictionary,{headers:{'Content-Type':'application/json'}}).then(({data})=>{
            dispatch({
                type: ADD_ALBUM,
                payload: {url:dictionary.Image,img:dictionary.isImage,data}
            });
	        dispatch({type: DISABLE, payload: false});
	        return data;
        })
    })
};
export const fetchAlbum=(data)=>{
    return (dispatch => {
        return axiosI.get(`${constants.API.getUserImagesByUserIdApi}/${data.UserId}/${data.UserId}/${data.PageSize}/${data.PageNumber}/${data.Latitude}/${data.Longitude}`).then(({data})=>{
            dispatch({
                type: GET_ALBUM,
                payload: data.results
            });
        })
    })
};

export const DeleteUserOwnFeed=(deleteImageFeedId)=>{
    return (dispatch => {
        return axiosI.post(constants.API.deleteUserOwnFeedApi,deleteImageFeedId).then(()=>{
            dispatch({
                type: DELETE_USEROWNFEED,
                payload: deleteImageFeedId
            });
        })
    })
};
